import { render } from "./ProjectDetail.vue?vue&type=template&id=6b4a358a&scoped=true"
import script from "./ProjectDetail.vue?vue&type=script&lang=js"
export * from "./ProjectDetail.vue?vue&type=script&lang=js"

import "./ProjectDetail.vue?vue&type=style&index=0&id=6b4a358a&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_omnia_1776687441006616365/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b4a358a"]])

export default __exports__